<template>
  <div class="all-table my-find" v-loading="loading">
    <div class="all-option clearfix">
    	<div class="all-option-one labels-list">
    		<ul>
    			<li v-for="item in category" :key="item.id"><a @click="chooseCategory(item)" href="javascript:;" :class="{'option-one-state':item.ischeck}">{{item.label}}</a></li>
    		</ul>
    	</div>
      <div class="fr changeLabelsBtn" @click="changeLabels">
        <img class="fl" src="../../assets/img/icon_edit.png" alt="">
        <span class="fl">修改标签</span>
      </div>
    </div>
    <div>
        <CourseList :frompage="frompage" @pagechange="pagechange" :total="total" :list="courselist"></CourseList>
    </div>
  </div>
</template>

<script>
import '../../assets/css/allcourse.css'
import {ApiGetkeyCategory,ApiGetCategoryChild, ApiGetMyLabel, ApiGetMyLabelCourse} from '../../net/course/index.js'
import CourseList from '../CourseList/courseList.vue'
export default {
  data: function () {
    return {
      str: '重点课程',
      category : [],
      total : 20,
      loading : false,
      courselist : [],
      currentid : null,
      frompage : 'ICourse',
    }
  },
  components: {
    CourseList,
  },
  computed: {
    refreshLabels: function () {
      return this.$store.state.refreshLabels
    }
  },
  watch: {
    refreshLabels (newVal, oldVal) {
      this.getgory()
    }
  },
  methods:{
    getgory(){
      const pramas = {
        pageNum: 1,
        pageSize: 999
      }
      ApiGetMyLabel(pramas).then(res=>{
        // console.log('res',res)
        if(res.code == 200){
          if (res.value.length == 0) {
            this.$store.commit('changeShowLabels', true)
            return
          }
          if(this.$route.query.id){
            this.category = res.value.map((item,index) => {
              return {...item,ischeck:item.id == this.$route.query.id ? true : false}
            })
            this.currentid = this.$route.query.id
          }else{
            this.category = res.value.map(function(item,index){
              return {...item,ischeck:index == 0 ? true : false}
            })
            this.currentid = this.category[0].id;
          }

          this.getCourse(1);
        }
      })
    },
    getCourse(index){
      this.loading = true
      const params= {
        labelId : this.currentid,
        pageNum : index,
        pageSize : 20,
      }
      ApiGetMyLabelCourse(params).then(res=>{
        // console.log(res)
        if(res.code == 200){
          this.total = res.value.total
          this.courselist = res.value.details || [];

        }
        this.loading = false
      }).catch(err=>{
          this.loading = false
        })
    },
    pagechange(index){
      this.getCourse(index);
    },
    chooseCategory(item){
      if(!item.ischeck){
        this.clicktype = 0;
        this.category = this.category.map(function(i){
          return {...i,ischeck : i.id == item.id ? true : false}
        })
        this.currentid = item.id;
        this.getCourse(1)
      }
    },
    changeLabels () {
      this.$store.commit('changeShowLabels', true)
    }
  },
  mounted() {
    this.getgory();
  }
}
</script>

<style scoped>
.my-find .all-option .labels-list{
  width: 1000px;
  float: left;
}
.changeLabelsBtn{
  cursor: pointer;
  margin-top: 20px;
  line-height: 32px;
}
.changeLabelsBtn img{
  width: 20px;
  height: 20px;
  margin-top: 6px;
  margin-right: 6px;
}
</style>



// WEBPACK FOOTER //
// src/components/MyFind/MyFind.vue